
 
import React, { useEffect } from 'react'
import Event from './eventImg/event-31-jan.webp'


const Event32 = () => {
    useEffect(() => {
        document.title = "ISHRAE knowledge talk on Demystifying Desiccant Dehumidification";
      }, []);
  return (
    <>
    <div className='eventheading'>

      <h1 className='text-center'>31 January 2026</h1>
        <h3 className='text-center'>ISHRAE knowledge talk on Demystifying Desiccant Dehumidification  </h3>
</div>
   <div className='container' id='calanderevent'>
    <img src={Event} alt='ISHRAE knowledge talk on Demystifying Desiccant Dehumidification'/>
     <button className='mb-4'><a href='https://ishraehq.in/Admin/CalenderEventMaster/Registration_new/qByC4KEQXGk=' target='_blank'>Register Now </a></button>
    </div>
    </>
  )
}

export default Event32




